import React from "react";
import { Box, useTheme, IconButton, CircularProgress } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link,  useNavigate } from 'react-router-dom';

import { useGetReportedCustomersQuery } from "state/api";
import { Header } from "components";

// Customers
const ReportedCustomers = () => {
  // theme
  const theme = useTheme();
  const navigate = useNavigate();
  // get data
  const { data, isLoading } = useGetReportedCustomersQuery();

  // data columns
  const columns = [
    {
      field: "_id",
      headerName: "ID",
      flex: 1,
    },
    {
      field: "username",
      headerName: "Username",
      flex: 0.5,
    },
    {
      field: "name",
      headerName: "Name",
      flex: 0.5,
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
    },
    {
      field: "phoneNo",
      headerName: "Phone No.",
      flex: 0.5,
    },
    // {
    //   field: "phoneNumber",
    //   headerName: "Phone Number",
    //   flex: 0.5,
    //   renderCell: (params) => {
    //     return params.value.replace(/^(\d{3})(\d{3})(\d{4})/, "($1) $2-$3"); // format phone number (123) 456-7890
    //   },
    // },
    // {
    //   field: "country",
    //   headerName: "Country",
    //   flex: 0.4,
    // },
    // {
    //   field: "occupation",
    //   headerName: "Occupation",
    //   flex: 1,
    // },
    {
      field: "reportCount",
      headerName: "Report Counts",
      flex: 0.5,
    },
    {
        field: "actions",
        headerName: "Report Details",
        flex: 0.5,
        renderCell: (params) => (
          <IconButton
            color="white"
            onClick={() => 
                {
                    console.log(params.row._id, 'Clickig on the row');
                    // return navigate(`/details/${params.row._id}`);
                    return navigate(`/reportedUserDetails`, {state: params.row });
                }
        
        }
          >
            <ArrowForwardIcon />
          </IconButton>
        ),
      },
  ];

  return (
    <Box m="1.5rem 2.5rem">
      {/* Header */}
      <Header title="REPORTED USERS" subtitle="List of Reported Users" />

      {/* Content */}
      <Box
        mt="40px"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.light,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButtom-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        {/* Grid table */}
        {isLoading ? (
          <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            <CircularProgress size="medium" style={{ width: 20, height: 20, color: 'white' }} />
          </Box>
        ) : (
          <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            {data && data.length > 0 ? (
              <DataGrid
                loading={isLoading || !data}
                getRowId={(row) => row._id}
                rows={data || []}
                columns={columns}
                sx={{ width: '100%' }}
              />
            ) : (
              <h1>No reported user details available</h1>
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ReportedCustomers;
